const React = require("react");

const Label = require("components/fields/layouts/Label");

class FieldWrapper extends React.Component {

    constructor(props) {
        super(props);
    }

    get classNames() {
        return [
            'form-element',
            (this.props.hasError === true) ? 'has-error' : ''
        ].join(' ');
    }

    render() {
        return (
            <div className={this.classNames} >
                <Label forHtml={this.props.fieldId} title={this.props.placeholder} >{this.props.label}</Label >
                {this.props.children}
            </div >
        );
    }

}

module.exports = FieldWrapper;
